import { render } from "./FreeBetCampaignGenerator.vue?vue&type=template&id=6faa8d29&scoped=true"
import script from "./FreeBetCampaignGenerator.vue?vue&type=script&lang=js"
export * from "./FreeBetCampaignGenerator.vue?vue&type=script&lang=js"

import "./FreeBetCampaignGenerator.vue?vue&type=style&index=0&id=6faa8d29&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6faa8d29"]])

export default __exports__